import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isValidDate } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedDinamisFields = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  let schema = {
    ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
    copy_address: yup.boolean().required(),
    contact_address: yup.string().when('copy_address', {
      is: false,
      then: (s) => s.required(),
      otherwise: (s) => s.notRequired(),
    }),
    contact_postcode: yup.string().when('copy_address', {
      is: false,
      then: (s) => s.required(),
      otherwise: (s) => s.notRequired(),
    }),
    license_plate: yup.string().required(),
    tax_office: yup.string().required(),
  };

  if (firstDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate: yup
        .object({
          day: yup.string().required(),
          month: yup.string().required(),
          year: yup.string().required(),
        })
        .test('isValidDate', greekMessages.mixed.isValidDate, isValidDate)
        .required(),
    };
  }

  if (secondDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate2: yup.object().when('only_driver', {
        is: false,
        then: (s) =>
          s
            .shape({
              day: yup.string().required(),
              month: yup.string().required(),
              year: yup.string().required(),
            })
            .test('isValidDate', greekMessages.mixed.isValidDate, isValidDate),
      }),
    };
  }

  return schema;
};


export const sharedDinamisSchemaBuilder = (...args) => yup.object(sharedDinamisFields(...args));
export default sharedDinamisSchemaBuilder;
